import React from "react";
import SeriesInfoPage from "../catalogue/SeriesInfoPage";
import { getTvShowGC } from "../../../store/actions/uploadMediaAction";
import { getTvShow } from "../../../services/shows";

const ViewShow = () => (
  <SeriesInfoPage
    idParam="tvshow_id"
    load={getTvShow}
    storeKey="generalContentObjShow"
    setInfo={getTvShowGC}
    pagePath={(id) => `/dashboard/show-info/${id}`}
    tagSuffix="-tvshow"
    showTrailer
  />
);

export default React.memo(ViewShow);
